import { trpc as ProductVersionType } from '@tencent/tpro_rmonitor_manage_server_product_version';
import { trpc as GetMetric } from '@tencent/tpro_rmonitor_metrics_server_get_metrics';
import { trpc as OverviewType } from '@tencent/tpro_rmonitor_metrics_server_overview';
import { WithTypeCast } from '@raft/utils';

// 大盘总览指标
export type DataType = WithTypeCast<OverviewType.rmonitor.metrics_server.DataType>;
export const { DataType } = OverviewType.rmonitor.metrics_server;
export type IOverviewDashboardReq = WithTypeCast<OverviewType.rmonitor.metrics_server.IOverviewDashboardReq>;
export type IOverviewRsp = WithTypeCast<OverviewType.rmonitor.metrics_server.IOverviewRsp>;
export type IGetVersionsDashboardReq = WithTypeCast<OverviewType.rmonitor.metrics_server.IGetVersionsDashboardReq>;
export type IGetVersionsDashboardRsp = WithTypeCast<OverviewType.rmonitor.metrics_server.IGetVersionsDashboardRsp>;
export type IVersionsReq = WithTypeCast<OverviewType.rmonitor.metrics_server.IVersionsReq>;
export type IVersionsRsp = WithTypeCast<OverviewType.rmonitor.metrics_server.IVersionsRsp>;
export type IVersion = WithTypeCast<OverviewType.rmonitor.metrics_server.IVersion>;

export type ISetReleaseInfoReq = WithTypeCast<ProductVersionType.rmonitor.manage_server.ISetReleaseInfoReq>;
export type ISetReleaseInfoRsp = WithTypeCast<ProductVersionType.rmonitor.manage_server.ISetReleaseInfoRsp>;
export type IReleaseVersion = WithTypeCast<ProductVersionType.rmonitor.manage_server.IReleaseVersion>;

export type IGetFieldDistinctDataReq = WithTypeCast<GetMetric.rmonitor.metrics_server.IGetFieldDistinctDataReq>;
export type IGetFieldDistinctDataRsp = WithTypeCast<GetMetric.rmonitor.metrics_server.IGetFieldDistinctDataRsp>;
// 指标大类，下面可能有多种子指标，见 MetricSubType
export const { MetricType } = GetMetric.rmonitor.metrics_server;
export type MetricType = WithTypeCast<GetMetric.rmonitor.metrics_server.MetricType>;

export type IGetDimensionDataReq = WithTypeCast<GetMetric.rmonitor.metrics_server.IGetDimensionDataReq>;
export type IGetDimensionDataRsp = WithTypeCast<GetMetric.rmonitor.metrics_server.IGetDimensionDataRsp>;
export type IGetSummaryReq = WithTypeCast<GetMetric.rmonitor.metrics_server.IGetSummaryReq>;
export type IGetSummaryRsp = WithTypeCast<GetMetric.rmonitor.metrics_server.IGetSummaryRsp>;
export type IGetDashboardDataReq = WithTypeCast<GetMetric.rmonitor.metrics_server.IGetDashboardDataReq>;
export type IOption = WithTypeCast<GetMetric.rmonitor.metrics_server.IOption>;
export type IGetDashboardDataRsp = WithTypeCast<GetMetric.rmonitor.metrics_server.IGetDashboardDataRsp>;
export type IDashboardData = WithTypeCast<GetMetric.rmonitor.metrics_server.IDashboardData>;
export type IFilter = WithTypeCast<GetMetric.rmonitor.common.IFilter>;
export type IGetTopDataReq = WithTypeCast<GetMetric.rmonitor.metrics_server.IGetTopDataReq>;
export type IGetTopDataRsp = WithTypeCast<GetMetric.rmonitor.metrics_server.IGetTopDataRsp>;

export type ISummaryInfo =
  WithTypeCast<GetMetric.rmonitor.metrics_server.ISummaryInfo>
  & {
    subtype?: MetricSubType,
    summaryName?: string
  };

// 合规自定义子类型（FIXME: 尽量不要跟协议类型混合使用，后续需要剥离）
export enum ComplianceSubType {
  ComplianceApiCount = 49,
  // 合规已解决问题个数
  CompliancePrivacyCount = 101,
  // 合规看板（前端自定值）
  ComplianceKanban = 102,
  ComplianceVersion = 103, // 合规版本纬度数据统计（前端自定值）
}
export type MetricSubType = WithTypeCast<GetMetric.rmonitor.metrics_server.MetricSubType>;
export const { MetricSubType } = GetMetric.rmonitor.metrics_server;
export type TimeType = WithTypeCast<GetMetric.rmonitor.metrics_server.TimeType>;
export const { TimeType } = GetMetric.rmonitor.metrics_server;
export type IDimensionRecord = WithTypeCast<GetMetric.rmonitor.metrics_server.IDimensionRecord>;

export type IDimensionData = WithTypeCast<GetMetric.rmonitor.metrics_server.GetDimensionListRsp.IDimensionData>;
export type IGetDimensionListReq = WithTypeCast<GetMetric.rmonitor.metrics_server.IGetDimensionListReq>;
export type IGetDimensionListRsp = WithTypeCast<GetMetric.rmonitor.metrics_server.IGetDimensionListRsp>;

export enum TimeRange {
  Day = 1,
  Week = 6,
  Month = 30
}

export enum DayType {
  Days = 'days'
}

// Bugly 异常类型
export enum ExceptionType {
  ElectronCrash = 'electron-crash',
  ElectronJsPromiseError = 'electron-js-promise-error',
  WebJsPromiseError = 'web-js-promise-error',
  Crash = 'crash',
  Anr = 'anr',
  Error = 'error',
  Foom = 'foom',
  Freeze = 'freeze'
}
